import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable( { providedIn: 'root' } )
export class MsalAuthenticationInterceptor implements HttpInterceptor {
  constructor() {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<any>> {
    let headers = request.headers;

    // Custom header logic (if you're using a custom pattern)
    const lazyUpdate = (headers as any)?.lazyUpdate;
    if (Array.isArray(lazyUpdate) && lazyUpdate.length > 0) {
      lazyUpdate.forEach((el: any) => {
        headers = headers.set(el.name, el.value);
      });
    }

    // Common headers
    headers = headers
      .set('Cache-Control', 'no-cache')
      .set('Pragma', 'no-cache')
      .set('AppType', 'B2C');

    // Set Content-Type only if not already set
    if (!headers.has('Content-Type')) {
      headers = headers.set('Content-Type', 'application/json');
    }

    const authReq = request.clone({ headers });
    return next.handle(authReq);
  }
}
